<template>
    <el-row type="flex" justify="center">
        <el-col :md="8" :xs="20" :sm="20" :lg="8">
            <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="80px" class="demo-ruleForm">
                <el-form-item label="手机号" prop="phone_num">
                    <el-input v-model.number="ruleForm2.phone_num"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pass">
                    <el-input type="password" v-model="ruleForm2.pass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="ruleForm2.checkPass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm2')">注册</el-button>
                    <el-button type="text" @click="pageToLogin">登录-></el-button>
                </el-form-item>
            </el-form>
        </el-col>
    </el-row>
</template>
<script>
import axios from 'axios';
import config from './config.js';
export default {
    data() {
        var checkphone_num = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            }
            setTimeout(() => {

                if (!this.isPoneAvailable(value)) {
                    callback(new Error('请输入正确的手机号'));
                } else {
                    callback();
                }

            }, 1000);
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.ruleForm2.checkPass !== '') {
                    this.$refs.ruleForm2.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm2.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            ruleForm2: {
                pass: '',
                checkPass: '',
                phone_num: ''
            },
            rules2: {
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
                phone_num: [
                    { validator: checkphone_num, trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //alert('submit!');
                    let _this = this;
                    axios({
                            method: 'post',
                            url: config.base_url + '/yun_table/users/register',
                            data: {
                                phone_num: _this.ruleForm2.phone_num,
                                passwd: _this.ruleForm2.pass
                            }
                        })
                        .then(function(response) {
                            //console.log(response.data)

                            _this.$message({
                                message: '注册成功',
                                type: 'success'
                            });
                            _this.pageToLogin();
                        })
                        .catch((err) => {
                            //console.log(err.response)
                            let err_data = err.response.data.err_msg
                            this.$message({
                                message: err_data,
                                type: 'error'
                            })
                        })

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },   resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        isPoneAvailable: function(pone) {
            var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
            if (!myreg.test(pone)) {
                return false;
            } else {
                return true;
            }
        },
        pageToLogin() {
            this.$router.push({
                path: '/login'
            })
        }
    }
}
</script>